import { getRouteApi } from '@tanstack/react-router'
import { HistoryTable } from 'bank-entity-history'
import { routes } from 'commons/constants/routes'
import { TableDataQa } from 'commons/types/enums'
import { mergeArrayToString } from 'commons/utils/mergeArrayToString'
import {
  DateTime,
  Info,
  Layer,
  Link,
  PageFace,
  PageSectionPrimary,
  PageSectionSecondary,
  PageV2,
  Table,
  UsPhoneLabel
} from 'ui/components'
import { Col2x, Row } from 'ui/themes/globalStyles'
import { CustomerVendorIn, CustomerVendorsDetails } from '~bank-customer-vendor/types'

const routeApi = getRouteApi('/_app/customer-vendors/$id')

const CustomerVendor = () => {
  const data = routeApi.useLoaderData() as CustomerVendorsDetails
  const {
    name,
    city,
    customerIn,
    email,
    externalId,
    createdAt,
    phone,
    state,
    street,
    updatedAt,
    vendorIn,
    website,
    zipCode,
    showOrbitLicense,
    dba,
    history,
    historyTotalCount,
    form: { historyPage, historySize }
  } = data
  const navigate = routeApi.useNavigate()

  // If you need to make changes
  // const { mutate } = useMutation({
  //   mutationFn: () =>
  //     Request.put('/api/bank/v1/external-license', {
  //       id: data.id,
  //       name: 'qwe',
  //       email: 'sdldsmsdmsf@ada.er'
  //     })
  // })

  // useEffect(() => {
  //   mutate()
  // }, [])

  return (
    <PageV2 title="Customer/Vendor" face={PageFace.SECONDARY} subTitle={name}>
      <PageSectionPrimary face="outlined" title="Customer/Vendor Information">
        <Row>
          <Col2x>
            <Info label="Name">{`${name} (${externalId})`}</Info>
          </Col2x>
          <Col2x>
            <Info label="Email">{email}</Info>
          </Col2x>
        </Row>
        <Row>
          <Col2x>
            <Info label="Phone">
              <UsPhoneLabel value={phone} />
            </Info>
          </Col2x>
          <Col2x>
            <Info label="Website">{website}</Info>
          </Col2x>
        </Row>
        <Row>
          <Col2x>
            <Info label="Address">{mergeArrayToString(', ', [city, zipCode, state, street])}</Info>
          </Col2x>
          <Col2x>
            <Info label="DBA">{dba}</Info>
          </Col2x>
        </Row>
        {showOrbitLicense && (
          <Row>
            <Col2x>
              <Info label="License">
                <Link
                  to="/licenses/$licenseId"
                  params={{ licenseId: showOrbitLicense.id.toString() }}
                >{`${showOrbitLicense.name} (${showOrbitLicense.licenseNumber})`}</Link>
              </Info>
            </Col2x>
          </Row>
        )}
        <Row>
          <Col2x>
            <Info label="Created At">
              <DateTime date={createdAt} withTime />
            </Info>
          </Col2x>
          <Col2x>
            <Info label="Updated At">
              <DateTime date={updatedAt} withTime />
            </Info>
          </Col2x>
        </Row>
      </PageSectionPrimary>
      <PageSectionSecondary face="outlined" title="Customer In">
        <Layer rounded shadowed stretch>
          <Table<CustomerVendorIn>
            dataQa="customerIn"
            columns={[
              {
                title: 'Company name',
                align: 'left',
                render: ({ id, name }) => (
                  <Link to={routes.bank.relationships.details} params={{ id: id.toString() }}>
                    {name}
                  </Link>
                )
              },
              {
                title: 'Added At',
                align: 'left',
                render: ({ addedAt }) => <DateTime date={addedAt} withTime />
              }
            ]}
            dataSource={customerIn.map((item) => ({ item }))}
          />
        </Layer>
      </PageSectionSecondary>
      <PageSectionSecondary face="outlined" title="Vendor In">
        <Layer rounded shadowed stretch>
          <Table<CustomerVendorIn>
            dataQa="vendorIn"
            columns={[
              {
                title: 'Company name',
                align: 'left',
                render: ({ id, name }) => (
                  <Link to={routes.bank.relationships.details} params={{ id: id.toString() }}>
                    {name}
                  </Link>
                )
              },
              {
                title: 'Added At',
                align: 'left',
                render: ({ addedAt }) => <DateTime date={addedAt} withTime />
              }
            ]}
            dataSource={vendorIn.map((item) => ({ item }))}
          />
        </Layer>
      </PageSectionSecondary>
      <PageSectionSecondary face="outlined" title="History">
        <Layer rounded shadowed stretch>
          <HistoryTable
            dataQa={TableDataQa.CUSTOMER_VENDORS_HISTORY}
            items={history}
            pagination={{
              page: historyPage,
              size: historySize,
              onChange: (page: number, size: number) => {
                navigate({ to: '.', search: (prev) => ({ ...prev, historyPage: page, historySize: size }) })
              },
              total: historyTotalCount
            }}
          />
        </Layer>
      </PageSectionSecondary>
    </PageV2>
  )
}

export default CustomerVendor
